export const experienceData = [
    {
        id: 1,
        company: 'Teaching Hub',
        jobtitle: 'Full Stack Web Developer Intern',
        startYear: 'June 2023',
        endYear: 'July 2023'
    },
    {
        id: 2,
        company: 'Diginique Techlabs',
        jobtitle: 'AI/ML Summer Project Intern',
        startYear: 'June 2023',
        endYear: 'July 2023'
    },
]